module.exports = __webpack_public_path__ + "img/pc_en_wechat_qrcode.56df51a3.png";